import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { User, UserX } from "lucide-react";
import { useTranslation } from "react-i18next";
import AdminSupportChat from "./AdminSupportChat";
import AdminGuestSupport from "./AdminGuestSupport";

const AdminSupport = () => {
  const { t } = useTranslation();
  return (
    <div className="space-y-6">
      <Tabs defaultValue="registered">
        <TabsList className="mb-4">
          <TabsTrigger value="registered" className="gap-2">
            <User className="w-4 h-4" />
            {t('admin.registeredUsers')}
          </TabsTrigger>
          <TabsTrigger value="guests" className="gap-2">
            <UserX className="w-4 h-4" />
            {t('admin.guests')}
          </TabsTrigger>
        </TabsList>
        <TabsContent value="registered"><AdminSupportChat /></TabsContent>
        <TabsContent value="guests"><AdminGuestSupport /></TabsContent>
      </Tabs>
    </div>
  );
};

export default AdminSupport;
